import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './components/login.component';
import { SessionWarningDialogComponent } from './components/session-warning/session-warning-dialog.component';
import { TimerComponent } from './components/timer/timer.component';
import { ValjOrganisationComponent } from './components/valj-organisation/valj-organisation.component';


@NgModule({
  declarations: [LoginComponent, SessionWarningDialogComponent, TimerComponent, ValjOrganisationComponent],
  imports: [CommonModule, SharedModule],
  exports: [LoginComponent],
})
export class AuthModule {}
